import { ShareWith, Y42AssetStatus, Y42Interval, Y42Metadata as Y42MetadataJSONSchema } from '@y42/json-schema';
import { isNotNullish } from '@y42/util/nullish';
import { METADATA_JSON_SCHEMA_URL } from './feature-json-schema-map';

// Get optional properties of interface
// https://stackoverflow.com/questions/53809467/typescript-how-get-optional-keys-of-type
type MappedC<A, B> = {
  [K in keyof A & keyof B]: A[K] extends B[K] ? never : K;
};

type OptionalKeys<T> = MappedC<T, Required<T>>[keyof T];
const optionalMetadataProperties: Record<OptionalKeys<Y42MetadataJSONSchema>, true> = {
  asset_last_verified_by: true,
  asset_last_verified_time: true,
  asset_status_message: true,
  asset_verify_every: true,
};

export class Y42MetadataGitModel implements Y42MetadataJSONSchema {
  constructor(obj?: Partial<Y42MetadataGitModel>) {
    this.$schema = METADATA_JSON_SCHEMA_URL;
    this.name = obj?.name ?? '';
    this.description = obj?.description ?? '';
    this.tags = obj?.tags ?? [];
    this.owners = obj?.owners ?? {
      user_ids: [],
      team_ids: [],
    };
    this.experts = obj?.experts ?? {
      user_ids: [],
      team_ids: [],
    };
    this.watchers = obj?.watchers ?? {
      user_ids: [],
      team_ids: [],
    };
    this.asset_status = obj?.asset_status ?? Y42AssetStatus.NoStatus;

    // Only assign optional properties if they are defined,
    // so we don't write `undefined` or `null` in git
    Object.keys(optionalMetadataProperties)
      .map((key) => key as keyof Y42MetadataJSONSchema)
      .filter((key) => isNotNullish(obj?.[key]))
      .forEach((key) => Object.assign(this, { [key]: obj?.[key] }));
  }

  $schema: string;
  name: string;
  description: string;
  tags: string[];
  owners: ShareWith;
  experts: ShareWith;
  watchers: ShareWith;
  asset_status: Y42AssetStatus;
  asset_verify_every?: Y42Interval | undefined;
  asset_status_message?: string | undefined;
  asset_last_verified_time?: string | undefined;
  asset_last_verified_by?: string | undefined;
}
